"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageHelper = exports.UrlParameters = exports.InquiryOfferTypesEnum = void 0;
const SymfonyRouter_1 = __importDefault(require("@react/common/SymfonyRouter/SymfonyRouter"));
const PageHelper_1 = __importDefault(require("@react/common/PageHelper/PageHelper"));
const FixtermOffer_1 = __importDefault(require("@react/web/SubscriptionOfferDetail/classes/FixtermOffer"));
var InquiryOfferTypesEnum;
(function (InquiryOfferTypesEnum) {
    InquiryOfferTypesEnum["FIXTERM"] = "subscription-fix-term";
    InquiryOfferTypesEnum["FLEXIBLE"] = "subscription-flexible";
    InquiryOfferTypesEnum["MINTERM"] = "subscription-min-term";
})(InquiryOfferTypesEnum || (exports.InquiryOfferTypesEnum = InquiryOfferTypesEnum = {}));
var UrlParameters;
(function (UrlParameters) {
    UrlParameters["CONTRACT_LENGTH"] = "contractLength";
    UrlParameters["INQUIRY_TYPE"] = "inquiryType";
    UrlParameters["MILEAGE"] = "mileage";
})(UrlParameters || (exports.UrlParameters = UrlParameters = {}));
function getUrl() {
    return new URL(window.location.href);
}
class PageHelper {
    static getMileageFromUrl() {
        return getUrl().searchParams.get(UrlParameters.MILEAGE);
    }
    static getContractLengthFromUrl() {
        return getUrl().searchParams.get(UrlParameters.CONTRACT_LENGTH);
    }
    static getInquiryTypeFromUrl() {
        return getUrl().searchParams.get(UrlParameters.INQUIRY_TYPE);
    }
    static updateSearchParams(searchParamsName, value) {
        const url = getUrl();
        url.searchParams.set(searchParamsName, String(value));
        window.history.replaceState({}, '', decodeURI(url.href));
    }
    static removeSearchParam(searchParamsName) {
        const url = getUrl();
        url.searchParams.delete(searchParamsName);
        window.history.replaceState({}, '', decodeURI(url.href));
    }
    static updateLikeButtonPriceOfferId(mileageYearly) {
        const likeButton = document.getElementById('like-subscription-price-offer-button');
        if (likeButton) {
            likeButton.dataset.priceOfferId = mileageYearly.priceOfferId;
        }
    }
    static getOfferInquiryUrl(offer) {
        if (offer instanceof FixtermOffer_1.default) {
            const route = PageHelper_1.default.isLoggedInAdminRole() ? 'cmd.inquiry.new_inquiry_fixterm' : 'subscription_inquiry_form_fixterm';
            return SymfonyRouter_1.default.getRoute(route, {
                contractLength: offer.contractLength,
                inquiryType: offer.inquiryType,
                mileageYearly: offer.mileageYearly,
                subscriptionOfferId: offer.subscriptionOfferId,
            });
        }
        const route = PageHelper_1.default.isLoggedInAdminRole() ? 'cmd.inquiry.new_inquiry' : 'subscription_inquiry_form';
        return SymfonyRouter_1.default.getRoute(route, {
            inquiryType: offer.inquiryType,
            mileageYearly: offer.mileageYearly,
            subscriptionOfferId: offer.subscriptionOfferId,
        });
    }
    static updateComparisonButtonPriceOfferData(currentDisplayedPriceOffer) {
        const compareSubscriptionOfferButton = document.getElementById('compare-subscription-offer-button');
        if (compareSubscriptionOfferButton !== null) {
            compareSubscriptionOfferButton.dataset.priceOfferType = currentDisplayedPriceOffer.inquiryType;
            if (currentDisplayedPriceOffer instanceof FixtermOffer_1.default) {
                compareSubscriptionOfferButton.dataset.priceOfferContractLength = String(currentDisplayedPriceOffer.contractLength);
            }
            else {
                compareSubscriptionOfferButton.dataset.priceOfferContractLength = '';
            }
        }
    }
}
exports.PageHelper = PageHelper;
